import React from "react";
import { isString } from "lodash";
import { injectIntl } from "@irati/utils/lang/injectIntl";
import getMessage from "@irati/utils/lang/helpers/getMessage";
var Text = injectIntl(function (props) {
    var formatMessage = props.formatMessage, values = props.values, children = props.children;
    var newChildren = isString(children) ? getMessage(formatMessage, children, values) : children;
    return React.createElement("div", null, newChildren);
});
export default injectIntl(Text);
